import "./src/styles/global.scss";

export const onRouteUpdate = ({ location }) => {
    const params = new URLSearchParams(location.search);
    const utmKeys = ["utm_source", "utm_medium", "utm_campaign"];
    utmKeys.forEach((key) => {
        const value = params.get(key);
        if (value) {
            sessionStorage.setItem(key, value);
        }
    });
};
